import { useRef } from 'react';
import { NextPageBtn } from '../../components/NextPageBtn/NextPageBtn';
import { Sections } from '../../types/Sections';
import { getTranslation } from '../../constants/translations';
import { MenuItems } from '../../types/MenuItems';
import { togglePage } from '../../helpers/togglePage';
import { Icons } from '../../components/Icons/Icons';
import { getLocalizedImg } from '../../helpers/getLocalizedImg';
import { getDefinedRegion } from '../../helpers/getRegion';

import saleNL from '../../assets/images/sale_NL.png';
import saleCOM from '../../assets/images/sale_COM.webp';

import './EasyBuy.scss';

export const EasyBuy = () => {
  const content = useRef();
  const t = getTranslation();
  const domen = getDefinedRegion();

  return (
    <section className="easy-buy main__easy-buy" id={Sections.EASYBUY}>
      <div className="easy-buy__container _grid">
        <div className="easy-buy__content" ref={content}>
          <h2 className="easy-buy__title">{t.EASY_BUY.title}</h2>
          <div className="easy-buy__sub-title">{t.EASY_BUY.subtitle}</div>
        </div>
        <NextPageBtn
          sectionId={Sections.ADVANTAGES}
          btnText={t.COMMON.firstNextPageBtn}
          customClassName="easy-buy__next-btn"
        />

        {domen === 'nl' && (
          <button
            className="easy-buy__sale"
            onClick={() => {
              togglePage(MenuItems.TOGETHER_SALE);
            }}
          >
            <img src={saleNL} alt="Sale" />
            <Icons name="sale-arrow2" customClassName="easy-buy__sale-arrow" />
          </button>
        )}
      </div>
    </section>
  );
};
